import React, { useState } from "react";
import {
    BookOpen,
    ChevronDown,
    ChevronUp,
    Globe,
    Scale,
    Sparkles,
    Triangle,
    Upload,
} from "lucide-react";

const ADIMLAR = [
    {
        no: 1,
        baslik: "Dosya bağla",
        metin: "Dosyalar sekmesinden sigorta dosyasını seçin. Marka, model ve model yılı otomatik gelir.",
        icon: BookOpen,
    },
    {
        no: 2,
        baslik: "Belgeleri yükle",
        metin: "Ekspertiz raporu ve onarım faturasını (isteğe bağlı sigorta teklifi) PDF veya fotoğraf olarak yükleyin. AI parça ve tutarları çıkarır.",
        icon: Upload,
    },
    {
        no: 3,
        baslik: "Parça piyasa taraması",
        metin: "Her parça için N11 ve açık web’de marka/model/yıla göre orijinal–muadil fiyat aranır; örnek ilanlar ve ekspertiz farkı netleştirilir.",
        icon: Globe,
    },
    {
        no: 4,
        baslik: "Üçgen karşılaştırma",
        metin: "Ekspertiz ↔ fatura ↔ sigorta tutarları parça bazlı tabloda; uyumsuzluklar ve uyumluluk skoru gösterilir.",
        icon: Triangle,
    },
    {
        no: 5,
        baslik: "Sunum & adli paket",
        metin: "Hukuk bürosu formatında sunum raporu, tek tık adli paket ve değer kaybı önizleme/aktarım.",
        icon: Scale,
    },
];

export default function EkspertizHasarModulGiris({ onBasla }) {
    const [acik, setAcik] = useState(true);

    return (
        <div className="rounded-2xl border border-[#D4AF37]/25 bg-gradient-to-br from-[#121A2F] via-[#0f172a] to-[#121A2F] overflow-hidden">
            <button
                type="button"
                onClick={() => setAcik((v) => !v)}
                className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left hover:bg-white/[0.02]"
            >
                <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded-xl bg-[#D4AF37]/15 flex items-center justify-center">
                        <Sparkles className="h-5 w-5 text-[#D4AF37]" />
                    </div>
                    <div>
                        <h2 className="font-display text-lg text-white">Hasar Uzmanı — Modül rehberi</h2>
                        <p className="text-xs text-slate-500 mt-0.5">
                            Ekspertiz & hasar farkı · internet piyasa istihbaratı · sunum raporu
                        </p>
                    </div>
                </div>
                {acik ? (
                    <ChevronUp className="h-5 w-5 text-slate-500 shrink-0" />
                ) : (
                    <ChevronDown className="h-5 w-5 text-slate-500 shrink-0" />
                )}
            </button>

            {acik ? (
                <div className="px-5 pb-5 space-y-4 border-t border-white/5">
                    <p className="text-sm text-slate-400 leading-relaxed pt-4">
                        Bu modül, sigorta hasar dosyalarında{" "}
                        <strong className="text-slate-200">ekspertiz ile gerçek fatura</strong> arasındaki
                        farkları, <strong className="text-slate-200">parça bazlı internet piyasa</strong>{" "}
                        verileriyle destekleyerek netleştirir. Rakamlar Türk Lirası formatında (₺1.234.567,89)
                        gösterilir. Değer kaybı aktarımı yalnızca onaylı butonla dosyaya yazılır.
                    </p>

                    <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
                        {ADIMLAR.map((a) => {
                            const Icon = a.icon;
                            return (
                                <div
                                    key={a.no}
                                    className="rounded-xl border border-white/10 bg-black/20 p-3"
                                >
                                    <div className="flex items-center gap-2 mb-2">
                                        <span className="text-[10px] font-bold text-[#D4AF37] bg-[#D4AF37]/10 px-1.5 py-0.5 rounded">
                                            {a.no}
                                        </span>
                                        <Icon className="h-3.5 w-3.5 text-slate-500" />
                                    </div>
                                    <div className="text-xs font-medium text-white">{a.baslik}</div>
                                    <p className="text-[10px] text-slate-500 mt-1 leading-snug">{a.metin}</p>
                                </div>
                            );
                        })}
                    </div>

                    {onBasla ? (
                        <button
                            type="button"
                            onClick={onBasla}
                            className="text-sm text-[#D4AF37] hover:underline"
                        >
                            Hasar Uzmanı sekmesine geç →
                        </button>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
